import axios from "axios";
import { createAgencyPayload, updateAgencyPayload } from "../../actions";
import { UTCNowUtil } from "../../utils/date-utils";
import { Agency } from "../../reducers/states/agency";

export const getAgencies = (): any => {
  return axios.get("/agencies/v1");
};

type postAgencyApiBody = Omit<createAgencyPayload, "jogIds"> & {
  jogIds: string[], // a number set in DynamoDB stores the numbers as strings, so they have to be passed that way.
  createdDate: string,
}

type putAgencyApiBody = Omit<updateAgencyPayload, "jogIds"> & {
  jogIds: string[], // a number set in DynamoDB stores the numbers as strings, so they have to be passed that way.
  lastModifiedDate: string,
}

export const postAgency = (payload: createAgencyPayload): any => {
  const body: postAgencyApiBody = {
    ...payload,
    // Setting date here, but createdBy is set by API template using auth context user
    // No easy way to set this date format in the API template
    createdDate: UTCNowUtil().toISOString(),
    jogIds: payload.jogIds?.map(id => id.toString()) || [],
  };

  return axios.post("/agencies/v1", body);
};

export const putAgency = (payload: Agency): any => {
  const id = payload.id;

  const fields = payload as any;
  delete fields.lastModifiedBy; // Set by API endpoint from auth context
  delete fields.jogId;  // obsolete field not allowed by API endpoint

  const body: putAgencyApiBody = {
    ...fields,
    // Setting date here but lastModifiedBy is set by API template using auth context user
    // No easy way to set this date format in the API template
    lastModifiedDate: UTCNowUtil().toISOString(),
    jogIds: payload.jogIds?.map(id => id.toString()) || [],

    // Primary contact fields should be defaulted to empty string by POST. So the PUT API expects/requires them since they should already exist in the original item.
    // todo: update API to accept primaryContactEmail // todo: jcavner: update API to allow/require this field
    //primaryContactEmail: fields.primaryContactEmail ?? "",
    // commenting these since this feature is TBD for now.
    // primaryContactName: fields.primaryContactName ?? "",
    // primaryContactPhoneNumber: fields.primaryContactPhoneNumber ?? "",
    // primaryContactUserId: fields.primaryContactUserId ?? "",
  };

  return axios.put(`/agencies/v1/${id}`, body);
};